import { jsx as e } from "@emotion/react/jsx-runtime";
import { Button as r, FontAwesomeIconsPartooUsed as a, IconPrefix as i } from "@partoohub/ui";
const p = ({
  dataTrackId: o,
  buttonText: t,
  onClick: n
}) => /* @__PURE__ */ e(r, { dataTrackId: o, type: "button", variant: "secondary", appearance: "outlined", shape: "cube", onClick: n, icon: [a.faCaretDown, i.SOLID], iconPosition: "right", children: t });
export {
  p as PageButton
};
